import { render } from "./DownloadPdf.vue?vue&type=template&id=3b7acddf&scoped=true"
import script from "./DownloadPdf.vue?vue&type=script&lang=js"
export * from "./DownloadPdf.vue?vue&type=script&lang=js"

import "./DownloadPdf.vue?vue&type=style&index=0&id=3b7acddf&lang=scss&scoped=true"

import exportComponent from "/home/jeim2750/develop.fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7acddf"]])

export default __exports__